module.exports = __webpack_public_path__ + "img/1-phone.4f6f5c5b.jpg";